import { Link, Accordion, AccordionDetails, AccordionSummary, Box, Typography} from '@mui/material';
import FilingSchedule from '../../../../../types/filers/fillingSchedule';
import FilingScheduleTable from './FilingScheduleTable';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Props {
    schedule?: FilingSchedule[]
    previousSchedule?: FilingSchedule[]
}

const FutureSchedules: FilingSchedule[] = [
    {
        "year": 2026,
        "description": "60 Day",
        "startDate": "1/1/2026",
        "endDate": "8/30/2026",
        "dueDate": "9/4/2026",
        "lateContributionSummary": ""
      },
      {
        "year": 2026,
        "description": "Sept. 20th",
        "startDate": "8/31/2026",
        "endDate": "9/15/2026",
        "dueDate": "9/21/2026",
        "lateContributionSummary": ""
      },
      {
        "year": 2026,
        "description": "Oct 5th",
        "startDate": "9/16/2026",
        "endDate": "10/1/2026",
        "dueDate": "10/5/2026",
        "lateContributionSummary": ""
      },
      {
        "year": 2026,
        "description": "Oct 20th",
        "startDate": "10/2/2026",
        "endDate": "10/15/2026",
        "dueDate": "10/20/2026",
        "lateContributionSummary": ""
      },
      {
        "year": 2026,
        "description": "Late Contribution Period",
        "startDate": "10/17/2026",
        "endDate": "10/30/2026",
        "dueDate": "within 72 hours of deposit",
        "lateContributionSummary": ""
      },
      {
        "year": 2026,
        "description": "Nov 5th",
        "startDate": "10/16/2026",
        "endDate": "11/1/2026",
        "dueDate": "11/5/2026",
        "lateContributionSummary": ""
      },
      {
        "year": 2026,
        "description": "Nov 20th",
        "startDate": "11/2/2026",
        "endDate": "11/15/2026",
        "dueDate": "11/20/2026",
        "lateContributionSummary": ""
      },
      {
        "year": 2026,
        "description": "Year-End",
        "startDate": "11/16/2026",
        "endDate": "12/31/2026",
        "dueDate": "1/20/2027",
        "lateContributionSummary": ""
      }
]


const BallotQuestionCommittee = (props: Props): JSX.Element => {

    return (
        <Box>
            <Typography variant="h6" gutterBottom fontWeight={600}>
                Ballot Question Committees
            </Typography>
            <Typography component={'span'} variant="subtitle1" gutterBottom>
                <b> Statewide Committees </b><Typography component={'span'} variant='subtitle2'>(<i>Questions appearing on a statewide ballot</i>)</Typography>:
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom>
                All committees organized to support or oppose a question on a state ballot are required to file periodic reports with OCPF in accordance with the following schedule. Before raising and spending fund, 
                click <Link href="https://www.ocpfreporter.us/OnlineOrganization/" target="_blank">here</Link> to organize a Ballot Question Committee.
                Please click <Link href="/PublicSearch/ViewDocument?id=3014" target="_blank">here</Link> for the campaign finance guide for state ballot question committees.
            </Typography>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontWeight={'bold'} variant={'subtitle1'}>Current Filing Schedule</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FilingScheduleTable schedules={props.schedule || []} bq={true} year={props.schedule && props.schedule[0] ? props.schedule[0].year : new Date().getFullYear()} />
                </AccordionDetails>
            </Accordion>

            <Accordion >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontWeight={'bold'} variant={'subtitle1'}>Previous Filing Schedule</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FilingScheduleTable schedules={props.previousSchedule || []} bq={true} year={props.previousSchedule && props.previousSchedule[0] ? props.previousSchedule[0].year : new Date().getFullYear()} />
                </AccordionDetails>
            </Accordion>

            <Typography marginTop={5} variant="h6" gutterBottom fontWeight={600}>
                Ballot Question Spending Reports
            </Typography>

            <Typography component={'span'} variant="subtitle1" gutterBottom>
                <b>Form CPF 22</b>
            </Typography>

            <Typography variant="body1" component={'p'} gutterBottom>
                Any corporation, association, organization or other group, other than a political committee organized with OCPF, must e-file the Form CPF 22 if it has given, paid, expended or contributed money or other thing of value in order to support or oppose a ballot question appearing on the ballot at a state election.
                Any individual who makes an expenditure of $250 or more to support or oppose a ballot question must also e-file the CPF 22 report.
                Click <Link href="https://ocpf2.blob.core.windows.net/pdf/forms/cpf_22.pdf" target="_blank">here</Link> for the Form CPF 22.
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom>
                The Form CPF 22 is e-filed on the same schedule as state ballot question committees (above).
            </Typography>
            

            <Typography component={'span'} variant="subtitle1" gutterBottom marginTop={2}>
                <b>Form CPF 22A</b>
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom>
                The Form CPF 22A is filed by governmental entities that use public funds or resources to affect the vote on a ballot question.
                Generally, the use of public resources for political purposes is prohibited.
                Click <Link href="https://ocpf2.blob.core.windows.net/pdf/forms/cpf_22a.pdf" target="_blank">here</Link> for the Form CPF 22A.
            </Typography>
        </Box>


    )
};

export default BallotQuestionCommittee;